import { navbar, initNavbar } from "../../components/navbar.js";

document.getElementById("navbar").innerHTML = navbar;

initNavbar();